// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"xLEaimc","wrapper__open":"_1NIO-n7","outerWrapper":"_1__Ug8F","slidedown":"_2Ydfmv-","wrapper__hidden":"_3YiroC7","innerWrapper":"_2jIx_En","body":"_4dx9Nn7","header":"Zb-NiHG","footer":"_2-UJgpr","close":"_3rZlkmo","container":"_2nFo01D"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Dropdown/index.css
// module id = ./template/components/Dropdown/index.css
// module chunks = client.sitechrome